/**
 * The fleet's one switch: may a driver take any free car, or only the cars the office
 * allowed him (#370).
 *
 * Saved the moment it is flipped, like everything else on this page — the page has no save
 * bar, its every control is an action. Off is a new firm's default; a small firm where
 * everybody drives everything turns it on, and the cars allowed to each driver are kept for
 * when it is turned off again.
 */

import { useTranslation } from 'react-i18next';

import { Section, SettingRow, Switch } from '../../ui';

export function WhoDrivesWhat({
  anyCar,
  busy,
  onChange,
}: {
  anyCar: boolean | null;
  busy: boolean;
  onChange: (anyCar: boolean) => void;
}) {
  const { t } = useTranslation();

  if (anyCar === null) return null;

  return (
    <Section title={t('fleet.allowed.sectionTitle')} description={t('fleet.allowed.sectionHelp')}>
      <SettingRow
        label={t('fleet.allowed.anyCar')}
        help={anyCar ? t('fleet.allowed.anyCarOn') : t('fleet.allowed.anyCarOff')}
        last
      >
        <Switch
          checked={anyCar}
          disabled={busy}
          label={t('fleet.allowed.anyCar')}
          onChange={onChange}
        />
      </SettingRow>
    </Section>
  );
}
